module.exports = "pegasus/assets/preview-8.png";